import { Component, OnInit } from '@angular/core';
import { StoreService, StoreKeys } from 'src/app/core/store/ngrx-store.service';
import { AppConfigService } from 'src/app/core/app-config/app-config-service';
import { AuthService } from 'src/app/core/services/auth.service';
@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {

  items: any[];
  userName = 'Guest User';

  constructor(
    private storeService: StoreService,
    private appConfigService: AppConfigService,
    public authService: AuthService) { }

  ngOnInit() {
    this.getUserName();
    this.items = [
      {
        label: 'EOL home',
        icon: 'ei ei-home ei-26',
        url: this.appConfigService.configuration.eolWebsiteUrl,
        tooltip: 'EOL homepage',
        showTooltip: true,
        targetBlank: true
      },
      { separator: true },
      {
        label: this.userName, icon: 'ei ei-user ei-26',
        items: [{
          label: 'Log off',
          icon: 'ei ei-exit ei-26',
          command: () => this.logout()
        }]
      }
    ];
  }

  logout(): void {
    this.authService.logOut();
  }

  getUserName() {
    this.storeService.Get(StoreKeys.UserDetails).subscribe(data => {
      this.userName = data.displayName;
    });
  }
}
